<template>
    <input
        class="form-control"
        ref="input"
        maxlength="100"
        :value="value"
        @input="updateValue($event.target.value)"
        @paste="$emit('paste')"
    />
</template>

<script>
export default {
    props: {
        value: [String, Number, null],
        pattern: {
            type: RegExp,
        }
    },
    methods: {
        updateValue: function(value) {
            if (this.pattern) {
                let formattedValue = value.replace(this.pattern, '');

                if (formattedValue !== value) {
                    this.$refs.input.value = formattedValue;
                    value = formattedValue;
                }  
            }

            this.$emit('input', value);
        }
    }
}
</script>